import { DataTypes } from './widgetDataTypes';

const FieldNames = {
    APP: 'app',
    SOURCE: 'source',
    OS: 'os',
    COUNTRY: 'country_field',
};

export const FILTER_CONFIG = [
    {
        key: 'source',
        fieldName: FieldNames.SOURCE,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_SOURCE',
        mixpanelEventName: 'Dashboards - Source Filter Changed',
        mixpanelPropertyName: 'source_names',
        displayName: 'Source',
    },
    {
        key: 'app',
        fieldName: FieldNames.APP,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_APP',
        mixpanelEventName: 'Dashboards - App Filter Changed',
        mixpanelPropertyName: 'app_names',
        displayName: 'App',
    },
    {
        key: 'os',
        fieldName: FieldNames.OS,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_OS',
        mixpanelEventName: 'Dashboards - OS Filter Changed',
        mixpanelPropertyName: 'os_names',
        displayName: 'OS',
    },
    {
        key: 'country_field',
        fieldName: FieldNames.COUNTRY,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_COUNTRY',
        mixpanelEventName: 'Dashboards - Country Filter Changed',
        mixpanelPropertyName: 'country_names',
        displayName: 'Country',
    },
];

export const createInitialFilterState = () => {
    return FILTER_CONFIG.reduce((acc, config) => {
        acc[config.key] = [];
        return acc;
    }, {});
};

export const createGlobalFilters = filters => {
    const globalFiltersList = [];

    FILTER_CONFIG.forEach(config => {
        const filterValues = filters[config.key];
        if (filterValues?.length) {
            globalFiltersList.push({
                field: config.key,
                operator: 'in',
                values: filterValues.map(f => f.value),
            });
        }
    });

    return globalFiltersList;
};

export const formatFilterOptions = items => {
    return (
        items?.map(item => ({
            value: item.name,
            label: item.display_name || item.name,
        })) || []
    );
};

export const getFilterOptions = filterFields => {
    return FILTER_CONFIG.reduce((options, config) => {
        const filter = filterFields?.find(f => f.name === config.fieldName);
        options[config.key] = filter?.values ? formatFilterOptions(filter.values) : [];
        return options;
    }, {});
};

export const FiltersBlacklistToReportType = {
    [DataTypes.SKAN]: [FieldNames.COUNTRY],
    [DataTypes.SKAN_RAW]: [FieldNames.COUNTRY],
    [DataTypes.UNIFIED]: [FieldNames.COUNTRY],
};

export const getBlockedWidgetFilterNames = (dataType, globalFilters) => {
    const filterFields = new Set(globalFilters.map(({ field }) => field));

    const blockedFilterFields = new Set(
        (FiltersBlacklistToReportType[dataType] || []).filter(blockedFilter => filterFields.has(blockedFilter))
    );

    return FILTER_CONFIG.filter(({ fieldName }) => blockedFilterFields.has(fieldName)).map(
        ({ displayName }) => displayName
    );
};
